<div class="overlay" *ngIf="ShowShipmentRequestPopup || ShowOrderCancelation || ShowOrderCopy || ShowEditContainer;"></div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowOrderCopy">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowOrderCopy = false; CurrentOrder = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'CopyOfferRequestTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'CopyOfferRequestDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowOrderCopy = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowOrderCopy = false;CopyOrder(CurrentOrder);">{{ 'AcceptAndContinueCopy' | translate }}</button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowOrderCancelation">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowOrderCancelation = false; CurrentOrder = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'CancelQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'CancelQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowOrderCancelation = false; CurrentOrder = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowOrderCancelation = false;CancelOrder(CurrentOrder);">{{ 'YesCancel' | translate }}</button>
    </div>
</div>

<div class="EditContainer ShipmentRequestPopUp animated fadeInDown" *ngIf="this.ShowShipmentRequestPopup == true;">
  <div class="EditContainerCloseButton" (click)="this.ShowShipmentRequestPopup = false;">
    <i class="material-icons">close</i>
  </div>
  <div class="EditContainerHeadder">
    <p class="EditContainerHeadderTitle">
      <span class="EditContainerReferenceNumber">{{'SendShipmentRequestPreparation' | translate}}</span>
    </p>
  </div>
  <div class="EditContainerBody" style="height: Calc(100% - 150px);padding-top: 20px;">
    <div class="ButtonsSubContainerCommands" *ngIf="this.parent.loading != true;">
      <div class="ButtonsSubContainerCell">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: auto; margin-left: 2.5%;float: left;">
          <mat-label>{{ 'ShippingResponsability' | translate }}</mat-label>
          <mat-select name="ShippingResponsability" [(ngModel)]="this.ShippingDetails.ShippingResponsability" [disabled]="this.parent.loading">
            <mat-option *ngFor="let s of this.ShippingResponsabilities;" [value]="s" matTooltip="{{s.Description}}" matTooltipClass='neutral-tool-tip'>
              {{s.Name}} ({{s.Description}})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ButtonsSubContainerCell">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: auto; margin-left: 2.5%;float: left;">
          <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
          <mat-select name="ShippingServiceType" [(ngModel)]="this.ShippingDetails.ShippingCompany" [disabled]="this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID == 0">
            <mat-option *ngFor="let s of this.ShippingCompanies;" [value]="s">
              <span>{{s.Name}}</span>
              <img class="ShippingCompanyImage" *ngIf="s.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + s.ImagePath" />
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ButtonsSubContainerCell">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: auto; margin-left: 2.5%;float: left;">
          <mat-label>{{ 'ShippingServiceType' | translate }}</mat-label>
          <mat-select name="ShippingServiceType" [(ngModel)]="this.ShippingDetails.ShippingServiceType" [disabled]="this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID == 0">
            <mat-option *ngFor="let s of this.ShippingServiceTypes;" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="EmailReceipientsContainer" *ngIf="this.ShippingDetails?.ShippingResponsability?.RequiresInsurance != null;">
      <p>{{'ProductsInsurance' | translate}}</p>
      <mat-slide-toggle [disabled]="ShippingDetails.ShippingResponsability?.RequiresInsurance" matTooltip="{{ 'RequestProductsInsuranceDescription' | translate}}" matTooltipClass='neutral-tool-tip' class="EmailReceipientsToggleSetting" [(ngModel)]="this.ShippingDetails.ShippingResponsability.Insurance">
        {{'RequestProductsInsurance' | translate}}
      </mat-slide-toggle>
      <div class="EmailReceipientsContainerInfo">
        {{ 'RequestProductsInsuranceDescription2' | translate}}
      </div>
    </div>

    <div class="EmailReceipientsContainer">
        <p>{{'CCEmailCopy' | translate}}</p>
        <div class="EmailAgent" *ngFor="let a of this.PartnerAgents;" (click)="a.IsSelected = !a.IsSelected;" [ngClass]="{'selectedAgent': a.IsSelected == true}">
            <i class="material-icons" *ngIf="a.IsSelected" style="color: #32aa3a;">check</i>
            <i class="material-icons" *ngIf="!a.IsSelected" style="color: #fd4f57;">close</i>
            <span>{{a.Email}}</span>
        </div>
    </div>

      <mat-form-field appearance="outline" class="ClientMessageText">
        <mat-label>{{ 'YouMessageForOurTeam' | translate }}</mat-label>
        <textarea autocomplete="off" matInput
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="5"
                  cdkAutosizeMaxRows="5"
                  [(ngModel)]="ClientMessage"></textarea>
      </mat-form-field>

      <p class="FinalDispatchInformation">
        <i class="material-icons">info_outline</i>
        <span>
          <span>({{this.ShippingDetails?.ShippingServiceType?.Name}})</span>
          <span class="NewLine">{{'ShippingCompany' | translate}} ({{this.ShippingDetails?.ShippingCompany?.Name}})</span>
        </span>
      </p>
  </div>

  <div class="EditContainerControlls" style="height: 90px;">
    <button (click)="SendDispatchEmailClientRequest();" [disabled]="this.parent.loading" class="SendShipmentRequestPopUpButton" mat-raised-button style="background-color: #32aa3a;" color="primary" *ngIf="this.ShippingDetails.ShippingServiceType">
      <i class="material-icons">check</i>
      <span style="margin-left: 10px;">{{'SendRequest' | translate}}</span>
    </button>
  </div>
</div>

<div class="EditContainer animated fadeInDown" *ngIf="this.ShowEditContainer == true;">
    <div class="EditContainerCloseButton" (click)="this.ShowEditContainer = false;">
        <i class="material-icons">close</i>
    </div>
    <div class="EditContainerHeadder">
      <p class="EditContainerHeadderTitle">
        <span class="EditContainerReferenceNumber">{{CurrentOrder.ReferenceNumber}}</span>
        <span class="EditContainerDebatorPO" *ngIf="CurrentOrder?.DebatorPO?.length > 0;">{{CurrentOrder.DebatorPO}}</span>
      </p>
    </div>
    <div class="EditContainerBody">

      <div class="EditContainerBodyStatus unSelectable">
        <span class="EditContainerBodyStatusTitle">Status: </span>
        <span class="OrdersRowColInfoStatusSpan" [ngClass]="{'NewOrderStatus': CurrentOrder.OfferRequestStatus.ID == 0, 'ProcessingOrderStatus': CurrentOrder.OfferRequestStatus.ID == 1,'PartiallyConfirmedOrderStatus': CurrentOrder.OfferRequestStatus.ID == 9,'ConfirmedOrderStatus': CurrentOrder.OfferRequestStatus.ID == 10, 'CanceledOrderStatus': CurrentOrder.OfferRequestStatus.ID == 11}">{{CurrentOrder.OfferRequestStatus.Name}}</span>
      </div>

      <div class="EditContainerBodySection">
        <div class="EditContainerBodySectionTitle unSelectable">
          <i class="material-icons">info</i>
          <span>{{'GeneralInfomration' | translate}}</span>
          <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderGeneralInformation = true;" *ngIf="this.ShowOrderGeneralInformation == false;">keyboard_arrow_right</i>
          <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderGeneralInformation = false;" *ngIf="this.ShowOrderGeneralInformation == true;">keyboard_arrow_down</i>
        </div>
  
        <div class="DottedSectionButton" *ngIf="this.ShowOrderGeneralInformation == false;" (click)="this.ShowOrderGeneralInformation = true;">
          <span>...</span>
        </div>
  
        <div *ngIf="this.ShowOrderGeneralInformation == true;">
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'RequestNumber' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'RequestNumber' | translate}}" [(ngModel)]="this.CurrentOrder.ReferenceNumber" matInput>
            </div>
          </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'DebatorPO' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input style="letter-spacing: 2px;font-weight: 500;color: #f60;" type="text" class="TextBoxContainer" placeholder="{{'DebatorPO' | translate}}" [(ngModel)]="this.CurrentOrder.DebatorPO" matInput>
              </div>
            </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'Uploader' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'UserUploader' | translate}}" [(ngModel)]="this.CurrentOrder.UserUploader.UIName" matInput>
              </div>
            </div>
    
            <div class="EditContainerBodyTextBoxContainer">
              <div class="TextBoxTitle">{{'Manager' | translate}}</div> 
              <div class="CentralTextBoxContainer">
              <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'UserUploader' | translate}}" [(ngModel)]="this.CurrentOrder.UserManager.UIName" matInput>
              </div>
            </div>
  
            <div class="CartSummary unSelectable CartSummarySmaller">
              <div class="CartSummaryTitle">
                <p>{{'OrderContactAgents' | translate}}</p>
              </div>
            
              <div class="PartnerAgentRow" *ngFor="let agent of this.CurrentOrder.Cart.Partner?.PartnerAgents" [ngClass]="{ 'UnSelectedAgent': agent.IsSelected != true}" (click)="agent.IsSelected = !agent.IsSelected;">
                <p>{{agent.Email}}</p>
                <i class="material-icons" *ngIf="agent.IsSelected == true;" style="color: #32aa3a;">check</i>
                <i class="material-icons" *ngIf="agent.IsSelected != true;" style="color: #fd4f57;">close</i>
              </div>
            </div>
        </div>
      </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">insert_drive_file</i>
            <span>{{'BillingInformation' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderBillingInformation = true;" *ngIf="this.ShowOrderBillingInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderBillingInformation = false;" *ngIf="this.ShowOrderBillingInformation == true;">keyboard_arrow_down</i>
          </div>
  
          <div class="DottedSectionButton" *ngIf="this.ShowOrderBillingInformation == false;" (click)="this.ShowOrderBillingInformation = true;">
            <span>...</span>
          </div>
  
         <div *ngIf="this.ShowOrderBillingInformation == true;">
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'Name' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Name' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.Name" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'VAT' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'VAT' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.VAT" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'COCRegNumber' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'COCRegNumber' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.COCRegNumber" matInput>
            </div>
          </div>

          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'Country' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Country' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.Country.Name" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'StateProvince' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'StateProvince' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.StateProvince" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'City' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'City' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.City" matInput>
            </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'AddressLine' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'AddressLine' | translate}}" [(ngModel)]="this.CurrentOrder.Cart.Partner.BillingAddress.AddressLine" matInput>
            </div>
          </div>
         </div>
        </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">airplanemode_on</i>
            <span>{{'ShippingAddresses' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderShippingInformation = true;" *ngIf="this.ShowOrderShippingInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderShippingInformation = false;" *ngIf="this.ShowOrderShippingInformation == true;">keyboard_arrow_down</i>
          </div>
  
          <div class="DottedSectionButton" *ngIf="this.ShowOrderShippingInformation == false;" (click)="this.ShowOrderShippingInformation = true;">
            <span>...</span>
          </div>
  
           <div *ngIf="this.ShowOrderShippingInformation == true;">
            <mat-form-field appearance="outline"class="EditContainerBodyDropDown" *ngIf="this.CurrentOrder.Cart.Partner.ShippingAddresses?.length > 0">
              <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
              <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentOrder.ShippingAddress" style="height: 30px;padding-top: 7px;">
                <mat-option *ngFor="let a of this.CurrentOrder.Cart.Partner.ShippingAddresses" [value]="a">
                  {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
                </mat-option>
              </mat-select>
            </mat-form-field>
  
          <mat-form-field appearance="outline" class="EditContainerBodyDropDown">
            <mat-label>{{ 'Country' | translate }}</mat-label>
            <mat-select disabled="true" name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentOrder.ShippingAddress.Country" style="height: 30px;padding-top: 7px;">
              <mat-option *ngFor="let c of this.parent.masterData.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <div class="EditContainerBodyTextBoxContainer">
            <div class="TextBoxTitle">{{'StateProvince' | translate}}</div> 
            <div class="CentralTextBoxContainer">
            <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'StateProvince' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.State" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'Partners.PartnerWindow.City' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.City' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.City" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'Partners.PartnerWindow.AddressLine' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.AddressLine' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.AddressLine" matInput>
          </div>
          </div>
  
          <div class="EditContainerBodyTextBoxContainer">
          <div class="TextBoxTitle">{{'ZipCode' | translate}}</div> 
          <div class="CentralTextBoxContainer">
          <input disabled="true" style="letter-spacing: 2px;font-weight: 500;" type="text" class="TextBoxContainer" placeholder="{{'ZipCode' | translate}}" [(ngModel)]="this.CurrentOrder.ShippingAddress.ZipCode" matInput>
          </div>
          </div>
           </div>
        </div>

        <div class="EditContainerBodySection">
          <div class="EditContainerBodySectionTitle unSelectable">
            <i class="material-icons">shopping_cart</i>
            <span>{{'Products' | translate}}</span>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderProductsInformation = true;" *ngIf="this.ShowOrderProductsInformation == false;">keyboard_arrow_right</i>
            <i class="material-icons OpenSectionArrow" (click)="this.ShowOrderProductsInformation = false;" *ngIf="this.ShowOrderProductsInformation == true;">keyboard_arrow_down</i>
          </div>

          <div class="DottedSectionButton" *ngIf="this.ShowOrderProductsInformation == false;" (click)="this.ShowOrderProductsInformation = true;">
            <span>...</span>
          </div>

          <div *ngIf="this.ShowOrderProductsInformation == true;">
            <div class="GridContainer" (keydown)="this.parent.handleKeyDown($event)">
              <div class="GridRow">
                <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px);">
                  #
                </div>
            
                <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(15% - 2px);">
                  {{'Brand' | translate}}
                </div>
            
              <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(45% - 2px);" matTooltip="{{ 'ProductNamePartNumberDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
                 {{'ProductNamePartNumber' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px);">
                {{'Quantity' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'Price' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'Total' | translate}}
              </div>
            
              <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10% - 2px);">
                {{'ETA' | translate}}
              </div>
              </div>
            
              <div class="GridRow" *ngFor="let item of this.CurrentOrder.Cart?.Items; let i = index;">
                <div class="GridCol" style="width: Calc(5% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{i + 1}}
                </div>
            
                <div class="GridCol leftText" style="width: Calc(15% - 2px);  cursor: pointer;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}" (click)="this.parent.InitializeSearchProduct(item);">
                  <span *ngIf="item?.CartItemStatus?.ID >= 0;">{{item?.Product?.Brand?.Name}}</span>
                  <span *ngIf="item?.CartItemStatus?.ID == -1;"></span>
                  <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand == null;">
                  </span>
                  <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand != null;">
                    {{item?.UserSelectedBrand?.Name}}
                  </span>
            
                  <div *ngIf="item.ShowBrandSearchResults == true;" class="GridBrandSearchResults">
                    <div class="GridBrandSearchResultsTopSearch">
                      <input type="text" placeholder="ex: SIEMENS" [(ngModel)]="this.parent.brandSearch" class="GridBrandSearchInput" matInput (ngModelChange)="this.parent.GetBrandsFilteredWithSuggestion(this.parent.brandSearch);"/>
                    </div>
                    <div class="GridBrandSearchResultsBody" *ngIf="this.parent.BrandsLoading != true;">
                      <div class="GridBrandSearchRow" *ngFor="let brand of this.parent.Brands; let b = index;" (click)="this.parent.SelectItemBrand(item, brand);">
                        <span>{{brand.Name}}</span>
                      </div>
                    </div>
                    <mat-spinner *ngIf="this.parent.BrandsLoading == true;" diameter="25" class="BrandsLoadingSpinner"></mat-spinner>
                  </div>
                </div>
            
                <div class="GridCol leftText" style="width: Calc(45% - 2px); background: #fff;padding-left: 0!important; cursor: pointer;" [ngClass]="{'awaitingChoiceMarkedRows': item?.CartItemStatus?.ID == -1, 'notFoundMarkedRows': item?.CartItemStatus?.ID == -2 && item?.WasSearchedFor == true, 'validMarkedRows': item?.CartItemStatus?.ID == 1, 'invalidMarkedRows': item?.CartItemStatus?.ID == 0}">
                  <textarea disabled="true" *ngIf="item.LoadingCell != true;" class="GridColFullText" type="text" (click)="this.parent.InitializeSearchProduct(item);" [(ngModel)]="item.UIProductValue" matInput (ngModelChange)="this.parent.searchTermUpdate.next($event)"></textarea>
                  <input disabled="true" *ngIf="item.LoadingCell == true;" class="GridColFullText" type="text" matInput (ngModelChange)="this.parent.OnlyNumbers($event)"/>
                  <i class="material-icons cellCheckIcon" *ngIf="item?.CartItemStatus?.ID == 1;">check</i>
                  <mat-spinner *ngIf="item.LoadingCell == true;" diameter="25" class="CellSpinner"></mat-spinner>
                  <div *ngIf="item.ShowSearchResults == true && item?.SearchResults?.length > 0;" class="itemChoiceContainer">
                    <div *ngFor="let s of this.item.SearchResults; let j = index;" class="cellSearchResultRow" (click)="this.parent.SelectGridSearchResult(s, item);" [ngClass]="{'SelectedOfferRow': s.IsSelected == true}">
                      <span>{{s.FKBrandName}}</span>  
                      <span>{{s.ProductName}}</span> <span *ngIf="s.ProductPartNumber?.length > 0;">(PN: {{s.ProductPartNumber}})</span>
                      <i class="material-icons SelectedGridSearchResult" *ngIf="s.IsSelected == true;">check</i>
                    </div>
                  </div>
                </div>
            
                <div class="GridCol" style="width: Calc(5% - 2px); background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  <div class="MOQSign" *ngIf="item?.SelectedOffer?.ChangedQunatityFromMOQ == true" matTooltip="{{'MOQDesc' | translate}} {{item.SelectedOffer.MOQ}}" matTooltipClass='neutral-tool-tip'></div>
                  <input disabled="true" class="GridColFullText" type="text" [(ngModel)]="item.Quantity" matInput *ngIf="item.Quantity > 0" (ngModelChange)="this.parent.OnlyNumbers($event)" (change)="this.parent.ChangeGridCellItem(item);"/>
                </div>
            
                <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{item.Price?.UIUnitPrice}} {{item.Price?.Currency?.Symbol}}
                </div>
            
                <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                  {{item.Price?.UIQtyPrice}} {{item.Price?.Currency?.Symbol}}
                </div>
            
              <div class="GridCol" style="width: Calc(10% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == -1" style="background: #f60;" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 0" style="background: #32aa3a;" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 1" matTooltip="{{item.RequestDeliveryStatus?.Name}}" matTooltipClass='neutral-tool-tip'></span>
                <span *ngIf="item.SelectedOffer?.LeadTime != null;">{{item.SelectedOffer?.LeadTime?.Units}} {{item.SelectedOffer?.LeadTime?.Type?.Name}}</span>
                <span *ngIf="item.SelectedOffer?.LeadTime == null;">------</span>
              </div>
              </div>
            </div>
          </div>
        </div>

    </div>

    <div class="EditContainerControlls">
      <button mat-raised-button color="primary" class="EditContainerControllsButton">
        <i class="material-icons">save_alt</i>
        <span>{{'Save' | translate}}</span>
      </button>

      <!-- <button mat-raised-button class="EditContainerControllsButton" style="float: right; margin-right: 2.5%;color: #fff;">
        <i class="material-icons">content_copy</i>
        <span>{{'Copy' | translate}}</span>
      </button> -->
    </div>
</div>

<div class="MainOrdersContainer" *ngIf="ShowOrderDetailsPage != true;">

 <!-- <div class="MyOrdersTitle">{{'ConfirmedOrders' | translate}} {{this.parent?.B2BPartner?.Name}}</div> -->

  <div class="ButtonsContainer">
    <div style="width: 50%;" class="OrderDetailsMenu" [ngClass]="{'SelectedOrderDetailsMenu': ShowOrders == true}" (click)="this.ShowOrdersClick();">
      <i class="material-icons">menu</i>
      <span>{{'Orders' | translate}}</span>
    </div>
  
    <div style="width: 50%;" class="OrderDetailsMenu" [ngClass]="{'SelectedOrderDetailsMenu': ShowOrders == false}" (click)="this.ShowReadyItems();">
      <i class="material-icons">insert_drive_file</i>
      <span>{{'ReadyItems' | translate}}</span>
    </div>
  </div>

  <div class="ButtonsSubContainer" *ngIf="ShowOrders == false;">
    <p class="ButtonsSubContainerTitle">{{'MyReadyItems' | translate}}</p>

    <div class="ButtonsSubContainerCommands" *ngIf="this.parent.loading != true;">
      <div class="ButtonsSubContainerCell">
        <button (click)="this.ShowShipmentRequestPopup = true" mat-raised-button color="primary" class="RequestItemsShipmentButton"  matTooltip="{{ 'RequestItemsShipmentDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
          <i class="material-icons" style="margin-right: 10px;">check</i>
          <span>{{'RequestItemsShipment' | translate}}</span>
        </button>
      </div>

      <div class="ButtonsSubContainerCell">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: auto; margin-left: 2.5%;float: left;">
          <mat-label>{{ 'ShippingResponsability' | translate }}</mat-label>
          <mat-select name="ShippingResponsability" [(ngModel)]="this.ShippingDetails.ShippingResponsability">
            <mat-option *ngFor="let s of this.ShippingResponsabilities;" [value]="s" matTooltip="{{s.Description}}" matTooltipClass='neutral-tool-tip'>
              {{s.Name}} ({{s.Description}})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ButtonsSubContainerCell">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: auto; margin-left: 2.5%;float: left;">
          <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
          <mat-select name="ShippingServiceType" [(ngModel)]="this.ShippingDetails.ShippingCompany" [disabled]="this.ShippingDetails?.ShippingResponsability?.ID == 0">
            <mat-option *ngFor="let s of this.ShippingCompanies;" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ButtonsSubContainerCell">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: auto; margin-left: 2.5%;float: left;">
          <mat-label>{{ 'ShippingServiceType' | translate }}</mat-label>
          <mat-select name="ShippingServiceType" [(ngModel)]="this.ShippingDetails.ShippingServiceType" [disabled]="this.ShippingDetails?.ShippingResponsability?.ID == 0">
            <mat-option *ngFor="let s of this.ShippingServiceTypes;" [value]="s">
              {{s.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      
    </div>

    <div class="ButtonsSubContainerCommands" *ngIf="this.parent.loading != true;">
      
    </div>

    <div class="OrderProductsTable" style="margin-top: 1%;">
      <div class="OrderProductsRow OrderProductsRowHeadder">
        <div class="OrderProductsCol" style="width: 5%;">
          {{'Position' | translate}}
        </div>
        <div class="OrderProductsCol" style="width: 10%;">
          {{'ConfirmationNumber' | translate}}
        </div>
        <div class="OrderProductsCol" style="width: 10%;">
          {{'YourInternalRefferenceNumber' | translate}}
        </div>
        <div class="OrderProductsCol" style="width: 15%;">
          {{'Brand' | translate}}
        </div>
        <div class="OrderProductsCol leftText" style="width: 20%;">
          {{'Product' | translate}}
        </div>
        <div class="OrderProductsCol" style="width: 10%;">
          {{'Quantity' | translate}}
        </div>
        <div class="OrderProductsCol" style="width: 15%;">
          {{'Price' | translate}}
        </div>
        <div class="OrderProductsCol" style="width: 15%;">
          {{'Total' | translate}}
        </div>
      </div>

      <div class="OrderProductsRow" *ngFor="let item of this.ReadyItems; let j=index;" [ngClass]="{'CanceledProductStatus': item.ProgressStatus.ID == -1, 'ReadyProductStatus': item.ProgressStatus.ID == 2, 'SendProductStatus': item.ProgressStatus.ID == 3}">
        <div class="OrderProductsCol" style="width: 5%;">
          <span class="OrderProductsColTitle">{{j + 1}}</span>
        </div>
        <div class="OrderProductsCol" style="width: 10%;">
          <span class="OrderProductsColTitle" style="color: #32aa3a;">{{item.CartItemOrderInfo.ReferenceNumber}}</span>
        </div>
        <div class="OrderProductsCol" style="width: 10%;">
          <span class="OrderProductsColTitle" style="color: #f60;">{{item.CartItemOrderInfo.DebatorPO}}</span>
        </div>
        <div class="OrderProductsCol" style="width: 15%;">
          <span class="OrderProductsColTitle">{{item.Product?.Brand?.Name}}</span>
        </div>
        <div class="OrderProductsCol" style="width: 20%;">
          <span class="OrderProductsColTitle leftText">{{item.Product?.Name}}</span>
          <p class="OrderProductsColProperty" *ngIf="item.Product?.PartNumber?.length > 0;">{{'PartNumber' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.PartNumber}}</span></p>
          <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.HSCode?.length > 0;">{{'HSCode' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.HSCode}}</span></p>
          <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.COO?.Name?.length > 0;">{{'COO' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.COO?.Name}} ({{item.Product?.Stats?.COO?.ShortName}})</span></p>
          <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.Weight != null;">{{'Weight' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.Weight}} {{item.Product?.Stats?.WeightMeasurementType?.Name}}</span></p>
        </div>
        <div class="OrderProductsCol" style="width: 10%;">
          <span class="OrderProductsColTitle">{{item.Quantity}}</span>
        </div>
        <div class="OrderProductsCol" style="width: 15%;">
          <span class="OrderProductsColTitle">{{item.Price.UIUnitPrice}} {{item.Price.Currency.Name}}</span>
        </div>
        <div class="OrderProductsCol" style="width: 15%;">
          <span class="OrderProductsColTitle">{{item.Price.UIQtyPrice}} {{item.Price.Currency.Name}}</span>
        </div>
      </div>

      <div style="background: #dce8f7;" class="OrderProductsRow" *ngIf="this.ReadyItemsTotal > 0;">
        <div class="OrderProductsCol" style="width: 5%;">
          <span class="OrderProductsColTitle"></span>
        </div>
        <div class="OrderProductsCol" style="width: 10%;">
          <span class="OrderProductsColTitle" style="color: #32aa3a;"></span>
        </div>
        <div class="OrderProductsCol" style="width: 10%;">
          <span class="OrderProductsColTitle" style="color: #f60;"></span>
        </div>
        <div class="OrderProductsCol" style="width: 15%;">
          <span class="OrderProductsColTitle"></span>
        </div>
        <div class="OrderProductsCol" style="width: 20%;">
          <span class="OrderProductsColTitle leftText"></span>
        </div>
        <div class="OrderProductsCol" style="width: 10%;">
          <span class="OrderProductsColTitle"></span>
        </div>
        <div class="OrderProductsCol" style="width: 15%;">
          <span class="OrderProductsColTitle">Total: </span>
        </div>
        <div class="OrderProductsCol" style="width: 15%;">
          <span class="OrderProductsColTitle">{{ReadyItemsTotal}} {{ReadyItemsTotalCurrency}}</span>
        </div>
      </div>
    </div>
  </div>

 <div class="ButtonsSubContainer" *ngIf="ShowOrders != false;">
  <div class="OrderControlls">
    <div class="MainTitleBar" style="overflow: hidden;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetB2BClientOrders();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer" style="margin-top: -4px;">
            <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetB2BClientOrders();">
              <mat-icon>filter_alt</mat-icon>
            </button>
        </div>
      
    </div>

    <div class="MainTitleBar" style="overflow: unset;">

      <div class="ActiveFiltersContainer">
        <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>

        <div class="TotalDocCountContainer">
          <span style="float: right;">{{this.Invoices?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Orders' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
          <div class="PageSizeContainer">
            <mat-form-field appearance="outline" class="PageSizeTextBox">
              <mat-label>{{ 'PageSize' | translate }}*</mat-label>
              <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetB2BClientOrders(1);">
            </mat-form-field>
          </div>
        </div>

        <div class="TotalDocCountContainer">
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetB2BClientOrders(this.Filter.Pager.PageIndex - 1);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetB2BClientOrders(this.Filter.Pager.PageIndex + 1);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>
        </div>
    </div>
  </div>

  <div class="OrdersTable">
    <div class="OrdersHeadder unSelectable">
        <div class="OrdersTableCol" style="width: 5%;">
            <p><i class="material-icons">numbers</i></p>
        </div>

        <div class="OrdersTableCol" style="width: 17.5%;">
            <p>{{'ID' | translate}}</p>
        </div>

        <div class="OrdersTableCol" style="width: 15%;">
            <p>{{'Status' | translate}}</p>
        </div>

        <div class="OrdersTableCol" style="width: 10%;">
            <p>{{'Date' | translate}}</p>
        </div>

        <div class="OrdersTableCol" style="width: 17.5%;">
            <p>{{'DebatorPO' | translate}}</p>
        </div>

        <div class="OrdersTableCol" style="width: 7.5%;">
            <p>{{'Total' | translate}}</p>
        </div>

        <div class="OrdersTableCol" style="width: 5%;">
            <p>{{'Currency' | translate}}</p>
        </div>

        <div class="OrdersTableCol" style="width: 12.5%;">
            <p>{{'Progress' | translate}}</p>
        </div>

        <div class="OrdersTableCol" style="width: 10%;">
            <p>{{'Actions' | translate}}</p>
        </div>
    </div>

    <div class="OrdersBody">
       <div *ngIf="this.loadingOrders == false;">
        <div class="OrdersRow" *ngFor="let o of this.Orders; let j=index;">
            <div class="OrdersTableCol" style="width: 5%;">
                <p style="font-weight: 300;">#{{j + 1}}</p>
            </div>
    
            <div (click)="GetClientOCDetails(o);" class="OrdersTableCol" style="width: 17.5%;color: #0082e6; cursor: pointer;">
                <p>{{o.ReferenceNumber}}</p>
            </div>
    
            <div class="OrdersTableCol" style="width: 15%;" [ngClass]="{'NewOCStatus': o.Status?.ID == 0, 'ProcessingOCStatus': o.Status?.ID == 1, 'CompletedOCStatus': o.Status?.ID == 10}">
                <p style="font-weight: 300;">{{o.Status?.Name}}</p>
            </div>
    
            <div class="OrdersTableCol" style="width: 10%; text-transform: uppercase;">
                <p style="font-weight: 300;">{{o.Date}}</p>
            </div>
    
            <div class="OrdersTableCol" style="width: 17.5%;">
                <p style="font-weight: 300;">{{o.PONumber}}</p>
            </div>
    
            <div class="OrdersTableCol" style="width: 7.5%;">
                <p style="font-weight: 300;">{{o.Total}}</p>
            </div>
    
            <div class="OrdersTableCol" style="width: 5%;">
                <p style="font-weight: 300;">{{o.Currency}}</p>
            </div>
    
            <div class="OrdersTableCol" style="width: 12.5%;">
                <div class="SendProductsPercentageUnit" *ngFor="let unit of o.SendProductsPercentageUnits;"></div>
                <p class="SendProductsPercentage" *ngIf="o.SendProductsPercentage > 0;">{{o.SendProductsPercentage}}%</p>
            </div>
    
            <div class="OrdersTableCol" style="width: 10%;">
                <button (click)="GetClientOCDetails(o);" class="DetailsButton" mat-flat-button>
                  <span *ngIf="o.IsLoading != true;">{{'Details' | translate}}</span>
                  <mat-spinner *ngIf="o.IsLoading == true;" diameter="20" class="DetailsButtonSpinner"></mat-spinner>
                </button>
            </div>
        </div>
       </div>
       <div *ngIf="this.loadingOrders == true;">
        <mat-spinner diameter="25" class="BrandsLoadingSpinner"></mat-spinner>
       </div>
    </div>
  </div>
 </div>
</div>

<div class="OrderDetailsContainer" *ngIf="ShowOrderDetailsPage == true;">
    <div class="OrderDetailsTitle">{{this.Order.ReferenceNumber}} / {{this.Order.EventRegisterUI}} - {{'DebatorPO' | translate}}: {{this.Order.DebatorPO}}</div>
    <div style="padding-bottom: 25px; border-bottom: solid 1px #aaa;" class="OrderDetailsTitle">Total: {{this.Order.Cart.Total.TotalQtyPriceNOVAT}} {{this.Order.Cart.Currency.Name}}</div>

    <div class="OrderDetailsMenu" [ngClass]="{'SelectedOrderDetailsMenu': ShowOrderDetailsMenu == true}" (click)="SelectOrderDetailsMenu();">
      <i class="material-icons">menu</i>
      <span>{{'Details' | translate}}</span>
    </div>
    <!-- <div class="OrderDetailsMenu" [ngClass]="{'SelectedOrderDetailsMenu': ShowOrderDocumentsMenu == true}" (click)="SelectOrderDocumentsMenu();">
      <i class="material-icons">insert_drive_file</i>
      <span>{{'Documents' | translate}} ({{this.Order?.Invoices?.length}})</span>
    </div> -->
    <div class="CrossLine"></div>
    <div class="OrderDetailsMenu SelectedOrderDetailsMenu" (click)="BackToOrders();">
      <i class="material-icons">arrow_back_ios_new</i>
      <span>{{'Back' | translate}}</span>
    </div>
    <!-- <div class="OrderDetailsMenu" [ngClass]="{'SelectedOrderDetailsMenu': ShowOrderTrackingMenu == true}">
      <i class="material-icons">near_me</i>
      <span>{{'Tracking' | translate}}</span>
    </div> -->

    <div class="OrderDetails" *ngIf="this.ShowOrderDetailsMenu == true;">
      <div class="OrderDetailsHalfContainer">
        <div class="OrderDetailsHalfContainerLabel">
            {{'OrderID' | translate}}
        </div>
        <div class="OrderDetailsHalfContainerText">
            {{this.Order.ReferenceNumber}}
        </div>

        <div class="OrderDetailsHalfContainerLabel">
          {{'DebatorPO' | translate}}
        </div>
        <div class="OrderDetailsHalfContainerText">
          {{this.Order.DebatorPO}}
        </div>

        <div class="OrderDetailsHalfContainerLabel">
          {{'OrderDate' | translate}}
        </div>
        <div class="OrderDetailsHalfContainerText">
          {{this.Order.EventRegisterUI}}
        </div>

        <div class="OrderDetailsHalfContainerLabel">
          {{'Client' | translate}}
        </div>
        <div class="OrderDetailsHalfContainerText">
          {{this.Order.Cart.Partner.Name}}
        </div>
      </div>
      <div class="OrderDetailsHalfContainer">
        <div class="OrderDetailsHalfContainerLabel">
          {{'Status' | translate}}
        </div>
        <div class="OrderDetailsHalfContainerText">
          {{this.Order.ProcessingStatus.Name}}
        </div>
        <div class="OrderDetailsHalfContainerText">
          {{this.Order.ProcessingStatus.Description}}
        </div>
        <div class="OrderDetailsHalfContainerText">
          {{'SendProductsProgress' | translate}}
        </div>

        <div class="OrderDetailsProgressContainer">
          <div class="OrderDetailsProgressContainerUnit" *ngFor="let unit of this.Order.OrderStatistics.SendProductsPercentageUnits;"></div>
          <p class="OrderDetailsProgressContainerUnitText">{{this.Order.OrderStatistics.SendProductsPercentage}}% {{'InvoicedSendProducts' | translate}}</p>
        </div>

        <div class="OrderDetailsProgressContainer">
          <div class="OrderDetailsReadyProgressContainerUnit" *ngFor="let unit of this.Order.OrderStatistics.ReadyProductsPercentageUnits;"></div>
          <p class="OrderDetailsReadyProgressContainerUnitText">{{this.Order.OrderStatistics.ReadyProductsPercentage}}% {{'ReadySendProducts' | translate}}</p>
        </div>

        <div class="LegendContainer">
          <div class="LegendContainerIcon" style="background: rgb(221,255,221);">{{this.Order.OrderStatistics.SendProductsPercentage}}%</div>
          <div class="LegendContainerText">{{'InvoicedSendProducts' | translate}}</div>
        </div>

        <div class="LegendContainer">
          <div class="LegendContainerIcon" style="background: #dce8f7;">{{this.Order.OrderStatistics.ReadyProductsPercentage}}%</div>
          <div class="LegendContainerText">{{'ReadySendProducts' | translate}}</div>
        </div>
      </div>

      <div class="OrderProductsTablePreTitle">
        {{'OpenOrdersProducts' | translate}}
      </div>
      <div style="margin-top: 10px;" class="OrderProductsTable">
        <div class="OrderProductsRow OrderProductsRowHeadder">
          <div class="OrderProductsCol" style="width: 5%;">
            {{'Position' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 20%;">
            {{'Brand' | translate}}
          </div>
          <div class="OrderProductsCol leftText" style="width: 25%;">
            {{'Product' | translate}}
          </div>
          <div class="OrderProductsCol leftText" style="width: 10%;">
            {{'LeadTime' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 10%;">
            {{'Quantity' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            {{'Price' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            {{'Total' | translate}}
          </div>
        </div>

        <div class="OrderProductsRow" *ngFor="let item of this.Order.Cart.OpenItems; let j=index;" [ngClass]="{'CanceledProductStatus': item.ProgressStatus.ID == -1, 'ReadyProductStatus': item.ProgressStatus.ID == 2, 'SendProductStatus': item.ProgressStatus.ID == 3}">
          <div class="OrderProductsCol" style="width: 5%;">
            <span class="OrderProductsColTitle">{{j + 1}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 20%;">
            <span class="OrderProductsColTitle">{{item.Product?.Brand?.Name}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 25%;">
            <span class="OrderProductsColTitle leftText">{{item.Product?.Name}}</span>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.PartNumber?.length > 0;">{{'PartNumber' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.PartNumber}}</span></p>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.HSCode?.length > 0;">{{'HSCode' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.HSCode}}</span></p>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.COO?.Name?.length > 0;">{{'COO' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.COO?.Name}} ({{item.Product?.Stats?.COO?.ShortName}})</span></p>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.Weight != null;">{{'Weight' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.Weight}} {{item.Product?.Stats?.WeightMeasurementType?.Name}}</span></p>
          </div>
          <div class="OrderProductsCol" style="width: 10%;">
            <span class="OrderProductsColTitle" *ngIf="item.SelectedOffer?.LeadTime?.ETAUI?.length > 0;">est. {{item.SelectedOffer?.LeadTime?.ETAUI}}</span>
            <span class="OrderProductsColTitle" *ngIf="!(item.SelectedOffer?.LeadTime?.ETAUI?.length > 0)">------</span>
          </div>
          <div class="OrderProductsCol" style="width: 10%;">
            <span class="OrderProductsColTitle">{{item.Quantity}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            <span class="OrderProductsColTitle">{{item.Price.UIUnitPrice}} {{item.Price.Currency.Name}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            <span class="OrderProductsColTitle">{{item.Price.UIQtyPrice}} {{item.Price.Currency.Name}}</span>
          </div>
        </div>
      </div>

      <div class="OrderProductsTablePreTitle">
        {{'ReadyInWarehouseOrdersProducts' | translate}}
      </div>
      <div style="margin-top: 10px;" class="OrderProductsTable">
        <div class="OrderProductsRow OrderProductsRowHeadder">
          <div class="OrderProductsCol" style="width: 5%;">
            {{'Position' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 20%;">
            {{'Brand' | translate}}
          </div>
          <div class="OrderProductsCol leftText" style="width: 25%;">
            {{'Product' | translate}}
          </div>
          <div class="OrderProductsCol leftText" style="width: 10%;">
            {{'LeadTime' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 10%;">
            {{'Quantity' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            {{'Price' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            {{'Total' | translate}}
          </div>
        </div>

        <div class="OrderProductsRow" *ngFor="let item of this.Order.Cart.ReadyItems; let j=index;" [ngClass]="{'CanceledProductStatus': item.ProgressStatus.ID == -1, 'ReadyProductStatus': item.ProgressStatus.ID == 2, 'SendProductStatus': item.ProgressStatus.ID == 3}">
          <div class="OrderProductsCol" style="width: 5%;">
            <span class="OrderProductsColTitle">{{j + 1}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 20%;">
            <span class="OrderProductsColTitle">{{item.Product?.Brand?.Name}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 25%;">
            <span class="OrderProductsColTitle leftText">{{item.Product?.Name}}</span>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.PartNumber?.length > 0;">{{'PartNumber' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.PartNumber}}</span></p>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.HSCode?.length > 0;">{{'HSCode' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.HSCode}}</span></p>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.COO?.Name?.length > 0;">{{'COO' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.COO?.Name}} ({{item.Product?.Stats?.COO?.ShortName}})</span></p>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.Weight != null;">{{'Weight' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.Weight}} {{item.Product?.Stats?.WeightMeasurementType?.Name}}</span></p>
          </div>
          <div class="OrderProductsCol" style="width: 10%;">
            <span class="OrderProductsColTitle" *ngIf="item.SelectedOffer?.LeadTime?.ETAUI?.length > 0;">est. {{item.SelectedOffer?.LeadTime?.ETAUI}}</span>
            <span class="OrderProductsColTitle" *ngIf="!(item.SelectedOffer?.LeadTime?.ETAUI?.length > 0)">------</span>
          </div>
          <div class="OrderProductsCol" style="width: 10%;">
            <span class="OrderProductsColTitle">{{item.Quantity}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            <span class="OrderProductsColTitle">{{item.Price.UIUnitPrice}} {{item.Price.Currency.Name}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            <span class="OrderProductsColTitle">{{item.Price.UIQtyPrice}} {{item.Price.Currency.Name}}</span>
          </div>
        </div>
      </div>

      <div class="OrderProductsTablePreTitle">
        {{'DeliveredOrdersProducts' | translate}}
      </div>

      <div class="fullWidth" *ngFor="let i of this.Order.Invoices; let j=index;">
        <div class="InvoiceContainer">
          <div class="InvoiceContainerTitle" (click)="GetInvoiceByAccountingDisplayValue(i, true);" matTooltip="{{ 'Print' | translate}}" matTooltipClass='neutral-tool-tip'>{{i.AccountingNumber.DisplayValue}}</div>
          <div class="InvoiceContainerButtons">
            <i class="material-icons" style="color: #32aa3a;"(click)="GetInvoiceByAccountingDisplayValue(i, false);" matTooltip="{{ 'Download' | translate}}" matTooltipClass='neutral-tool-tip'>file_download</i>
            <i class="material-icons" (click)="GetInvoiceByAccountingDisplayValue(i, true);" matTooltip="{{ 'Print' | translate}}" matTooltipClass='neutral-tool-tip'>local_print_shop</i>
          </div>
        </div>
  
        <div *ngIf="i.Details?.ShippingDetails?.ShippingCompany?.Name?.length > 0;" class="InvoiceTrackingButtonContainer" (click)="this.parent.RedirectToURLWithUrlChangeNewTab(i.Details.ShippingDetails.ShippingCompany.TrackingUrl);">
          <div class="InvoiceContainerTitle" matTooltip="{{ 'Track' | translate}}" matTooltipClass='neutral-tool-tip'>{{'Track' | translate}} ({{i.Details?.ShippingDetails?.ShippingCompany?.Name}})</div>
          <div class="InvoiceContainerButtons">
            <img *ngIf="i.Details.ShippingDetails?.ShippingCompany?.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + i.Details?.ShippingDetails?.ShippingCompany?.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
            <i class="material-icons" style="color: #32aa3a;" matTooltip="{{ 'Track' | translate}}" matTooltipClass='neutral-tool-tip'>near_me</i>
          </div>
        </div>
      </div>
     
      <div style="margin-top: 10px;" class="OrderProductsTable">
        <div class="OrderProductsRow OrderProductsRowHeadder">
          <div class="OrderProductsCol" style="width: 5%;">
            {{'Position' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 20%;">
            {{'Brand' | translate}}
          </div>
          <div class="OrderProductsCol leftText" style="width: 25%;">
            {{'Product' | translate}}
          </div>
          <div class="OrderProductsCol leftText" style="width: 10%;">
            {{'LeadTime' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 10%;">
            {{'Quantity' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            {{'Price' | translate}}
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            {{'Total' | translate}}
          </div>
        </div>

        <div class="OrderProductsRow" *ngFor="let item of this.Order.Cart.DeliveredItems; let j=index;" [ngClass]="{'CanceledProductStatus': item.ProgressStatus.ID == -1, 'ReadyProductStatus': item.ProgressStatus.ID == 2, 'SendProductStatus': item.ProgressStatus.ID == 3}">
          <div class="OrderProductsCol" style="width: 5%;">
            <span class="OrderProductsColTitle">{{j + 1}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 20%;">
            <span class="OrderProductsColTitle">{{item.Product?.Brand?.Name}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 25%;">
            <span class="OrderProductsColTitle leftText">{{item.Product?.Name}}</span>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.PartNumber?.length > 0;">{{'PartNumber' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.PartNumber}}</span></p>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.HSCode?.length > 0;">{{'HSCode' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.HSCode}}</span></p>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.COO?.Name?.length > 0;">{{'COO' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.COO?.Name}} ({{item.Product?.Stats?.COO?.ShortName}})</span></p>
            <p class="OrderProductsColProperty" *ngIf="item.Product?.Stats?.Weight != null;">{{'Weight' | translate}}: <span class="OrderProductsColPropertyResult">{{item.Product?.Stats?.Weight}} {{item.Product?.Stats?.WeightMeasurementType?.Name}}</span></p>
          </div>
          <div class="OrderProductsCol" style="width: 10%;">
            <span class="OrderProductsColTitle" *ngIf="item.SelectedOffer?.LeadTime?.ETAUI?.length > 0;">est. {{item.SelectedOffer?.LeadTime?.ETAUI}}</span>
            <span class="OrderProductsColTitle" *ngIf="!(item.SelectedOffer?.LeadTime?.ETAUI?.length > 0)">------</span>
          </div>
          <div class="OrderProductsCol" style="width: 10%;">
            <span class="OrderProductsColTitle">{{item.Quantity}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            <span class="OrderProductsColTitle">{{item.Price.UIUnitPrice}} {{item.Price.Currency.Name}}</span>
          </div>
          <div class="OrderProductsCol" style="width: 15%;">
            <span class="OrderProductsColTitle">{{item.Price.UIQtyPrice}} {{item.Price.Currency.Name}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="OrderDetails" *ngIf="this.ShowOrderDocumentsMenu == true;">
        <div class="InvoiceContainer" *ngFor="let i of this.Order.Invoices; let j=index;">
          <div class="InvoiceContainerTitle" (click)="GetInvoiceByAccountingDisplayValue(i, true);">{{i.AccountingNumber.DisplayValue}}</div>
          <div class="InvoiceContainerButtons">
            <i class="material-icons" style="color: #32aa3a;" (click)="GetInvoiceByAccountingDisplayValue(i, false);">file_download</i>
            <i class="material-icons" (click)="GetInvoiceByAccountingDisplayValue(i, true);">local_print_shop</i>
          </div>
        </div>
    </div>
</div>
